import React from 'react';
import IconMinus from 'utils/icon/icon-minus.svg';
import clsx from 'clsx';
import IconPlus from 'utils/icon/icon-plus.svg';

const QuantityInput = ({ quantity, max, title, updateCart, setQuantity, lineItem, cartLoading }) => {
  const handleInput = (e) => {
    const rawValue = e.target.value;
    const value = parseInt(rawValue, 10);

    if (rawValue === '') {
      setQuantity('');
    } else if (!Number.isNaN(value) && value >= 1 && (max === undefined || value <= max)) {
      setQuantity(value);
    }
  };

  const handleBlur = () => {
    // if formQuantity is empty on blur on the PDP, set it to 1
    if (!updateCart && quantity === '') {
      setQuantity(1);
    }

    if (quantity >= 1 && updateCart) {
      updateCart([{ id: lineItem.id, quantity }]);
    }
  };

  const handleDecrease = () => {
    if (quantity > 1) {
      if (updateCart) updateCart([{ id: lineItem.id, quantity: quantity - 1 }]);
      setQuantity(quantity - 1);
    }
  };

  const handleIncrease = () => {
    if (max === undefined || quantity < max) {
      if (updateCart) updateCart([{ id: lineItem.id, quantity: quantity + 1 }]);
      setQuantity(quantity + 1);
    }
  };

  return (
    <div className="qty-input body-3 relative flex h-10 content-center justify-between rounded-3xl border px-5">
      <button
        onClick={handleDecrease}
        type="button"
        aria-label={window.TMW.Strings.cart.remove}
        className="hover:text-brand-tangerine [&>svg]:size-3"
        disabled={cartLoading}
      >
        <IconMinus />
      </button>
      <input
        type="number"
        value={quantity}
        className="body-3 my-auto w-7 !border-none px-0  text-center !ring-0"
        onInput={handleInput}
        onBlur={handleBlur}
        max={max}
        id="quantity"
        aria-label={title}
        disabled={cartLoading}
      />
      <button
        onClick={handleIncrease}
        type="button"
        aria-label={window.TMW.Strings.cart.add}
        className={clsx('hover:text-brand-tangerine [&>svg]:size-3')}
        disabled={cartLoading}
      >
        <IconPlus />
      </button>
    </div>
  );
};

export default QuantityInput;
